import "babel-polyfill";
import {binder, fwa} from "./lib/binder";

import {homePage} from "./pages/homepage";
import {eventsPage} from "./pages/events";
import {globalSite} from "./pages/global_site";
import {articlePage} from "./pages/articles";
import {articleDetailPage} from "./pages/article_detail";
import {eventDetailPage} from "./pages/event_detail";
import {chronicleDetailPage} from "./pages/chronicle_detail";
import {chroniclePage} from "./pages/chronicle";
import { suggestEventPage} from "./pages/suggest_an_events";

binder({
    bounds: {
        "html": [
            homePage,
            eventsPage,
            globalSite,
            articlePage,
            articleDetailPage,
            eventDetailPage,
            chronicleDetailPage,
            chroniclePage,
            suggestEventPage
        ],
    },
    runTests: false
});


// WEBPACK FOOTER //
// ./assets/js/global.js